export const allErrorList = {
    'general': 'Bir hata oluştu',
    'busy_time_exceed': 'Yoğunluk bitiş saati aşıldı',
    'cannot_mark_as_coming_soon': 'Daha önce aktif edilmiş bir mağaza için Yakında seçeneği seçilemez',
    'free_usage_days_count_exceed': 'Kalan tatil kullanım hakları aşıldı'

}